
import { Options, Vue } from "vue-class-component";
import SvgIcon from "@/components/ui/icons/SvgIcon.vue";

@Options({
  name: "ZeroState",
  components: {
    SvgIcon,
  },
})
export default class ZeroState extends Vue {}
